import STREAM_TYPE from './STREAM_TYPE';

export default {
  [STREAM_TYPE.GUEST]: 0,
  [STREAM_TYPE.HOST_CAMERA]: 1,
  [STREAM_TYPE.HOST_MERGED]: 2,
  [STREAM_TYPE.MOBILE]: 3,
  [STREAM_TYPE.RTMP]: 4,
  [STREAM_TYPE.SCREEN]: 5,
  [STREAM_TYPE.SLIDE]: 6,
  [STREAM_TYPE.HOST_SUBSCRIBER]: 7,
  [STREAM_TYPE.COMPOSER]: 8,
  local: 12,
  [STREAM_TYPE.ISO_MOBILE]: 13,
  [STREAM_TYPE.ISO_SCREEN]: 14,
  [STREAM_TYPE.ISO_GUEST]: 15,
};
